import { bus } from "./bus";

if (location.host.includes('globalhatikvah')) {
  // var script = document.createElement('script');
  // script.type = 'text/javascript';
  // script.src = 'https://usermotif.com/scripts/gh.js'; // For external scripts
  // document.head.appendChild(script);


  (() => {
    const CSS = (cssString) => {
      const styleElement = document.createElement('style');

      if (styleElement.styleSheet) {
        styleElement.styleSheet.cssText = cssString;
      } else {
        styleElement.appendChild(document.createTextNode(cssString));
      }

      document.head.appendChild(styleElement);
    }

    CSS(`
    .song-intro .breadcrumb a {
      pointer-events: none;
    }
    .song-intro .breadcrumb span {
      color: #4a4a4a;
    }

    .song-intro .breadcrumb ul li.is-active {
      display: none;
    }

    .songintro .breadcrumb ul li.is-active + span,
    .songintro .breadcrumb ul li.is-active + div {
      display: none;
    }


    nav.studio-toolbar {
      display: none;
    }
    .song-tracks > div > .notification {
      display: none;
    }

    [data-i18n-section="studio actionbtns"] .control:last-child {
      display: none;
    }

    .modal .auth-btn {
      display: none;
    }
    button[aria-controls="help-menu"] {
      display: none;
    }

    .button.load-all-tracks {
      display: none;
    }
    .button.preload {
      display: none;
    }

    #vid-0 {
      max-width: 450px;
      width: 450px;
    }

    body, p, h1, h2, h3, h4, h5, h6, button, input, select {
      font-family: "Work Sans", Sans-serif;
    }

    .modal-card-body {
      background: linear-gradient(to right,    rgb(135, 59, 171) 0%,    rgb(151, 63, 169) 10%,    rgb(167, 67, 167) 20%,    rgb(182, 73, 163) 30%,    rgb(198, 82, 156) 40%,    rgb(212, 93, 147) 50%,    rgb(226, 106, 139) 60%,    rgb(232, 136, 104) 70%,    rgb(238, 145, 103) 80%,    rgb(244, 157, 102) 90%,    rgb(254, 179, 104) 100%);
      color: black;
      font-weight: 500;
      font-size: 24px;
    }
    `)

    const addFont = href => {
      var link = document.createElement('link');
      link.href = href
      link.rel = 'stylesheet';

      document.head.appendChild(link);
    }
    addFont('https://fonts.googleapis.com/css2?family=Work+Sans:wght@400;700&display=swap')

    const $ = s => document.querySelector(s)
    const $$ = s => Array.from(document.querySelectorAll(s))

    function getElementByText(text, parent = document) {
      const elements = parent.querySelectorAll("*");
      return Array.from(elements).find(element => element.textContent.trim() === text);
    }

    function parseJWT(token) {
      if (!token) return
      // Split the JWT into its three parts
      const parts = token.split('.');
      if (parts.length !== 3) {
        throw new Error('The token is invalid');
      }

      // Decode the Header and Payload parts from Base64Url
      const decodedHeader = JSON.parse(window.atob(parts[0].replace(/-/g, '+').replace(/_/g, '/')));
      const decodedPayload = JSON.parse(window.atob(parts[1].replace(/-/g, '+').replace(/_/g, '/')));

      return {
        header: decodedHeader,
        payload: decodedPayload
      };
    }
    const userId = parseJWT(localStorage['feathers-jwt'])?.payload?.sub

    const raf = () => new Promise(requestAnimationFrame)
    const callback = async (mutationsList, observer) => {
      const addTrackBtn = $(`[data-i18n-section="studio actionbtns"] .has-addons`)
      if (addTrackBtn && !addTrackBtn.dataset.gh) {
        addTrackBtn.classList.remove('has-addons')
        addTrackBtn.classList.add('has-text-weight-bold')
        addTrackBtn.dataset.gh = true
      }
      const addTrackLink = $(`[data-i18n-section="studio actionbtns"] .field a`)
      if (addTrackLink && addTrackLink.innerText !== 'Click to sing along') {
        addTrackLink.innerText = 'Click to sing along'
      }

      if ($('.modal .buttons')?.children.length <= 2) {
        Array.from($$('#auth-options .dropdown-item')).forEach(n => {
          $('.modal .buttons').prepend(n)
          n.addEventListener('click', (event) => {
            event.stopImmediatePropagation();

            if (event.target.innerText.toLowerCase().includes('google')) {
              openOAuthPopup('google')
            }
            if (event.target.innerText.toLowerCase().includes('microsoft')) {
              openOAuthPopup('microsoft')
            }
          }, true);
          n.classList = 'button is-link'
        })
      }

      $('input#agc')?.closest('.column').classList.add('is-hidden')
      $('select[name="avrec"]')?.closest('select').classList.add('is-hidden')
      $('.tags-input')?.closest('.columns').classList.add('is-hidden')
      $('.recording-page .columns')?.classList.add('is-hidden')
      const trackTitle = $('.tags-input')?.closest('.columns')?.querySelectorAll('input')[1]
      if (trackTitle && !trackTitle.value.includes('user')) {
        trackTitle.value += ` (user ${userId})`
      }

      const addToSong = getElementByText('Add to Song!')?.querySelector('a')
      if (addToSong) {
        addToSong.classList.add('has-text-weight-bold')
        addToSong.innerText = 'Upload!'
      }
      const singalong = $('.recording-page #sing-along')
      if (singalong) {
        for (const node of singalong.childNodes) {
          if (node.nodeType === Node.TEXT_NODE) {
            node.nodeValue = node.nodeValue.replace('Start Recording', 'Sing')
            break;
          }
        }

      }
      await raf()
      const discardRecording = $('.recording-page .is-danger.is-outlined')
      if (discardRecording) {
        discardRecording.textContent = 'Start Over'
      }

      $('.recording-page .button.is-danger')?.classList.add('is-outlined')

      const signInModalText = getElementByText('Please sign in to record a track')
      if (signInModalText) {
        signInModalText.innerHTML = `Please use your Microsoft or Google account to <br>
        sign in with our technology partner, EasyVirtualChoir`
      }

      const focusMode = getElementByText('Enter Focus Mode')?.closest('.button')
      if (focusMode) {
        focusMode.classList.add('is-hidden')
      }
    };

    const observer = new MutationObserver(callback);

    observer.observe(document.documentElement, { childList: true, subtree: true });
    callback()


    function extractIdFromPath(path) {
      const regex = /\/?song\/(\d+)\/?/;
      const match = path.match(regex);
      return match ? match[1] : null;
    }
    function openOAuthPopup(provider = 'google') {
      const oauthUrl = 'https://easyvirtualchoir.com/oauth/' + provider;
      const width = 500;
      const height = 600;
      const left = (screen.width / 2) - (width / 2);
      const top = (screen.height / 2) - (height / 2);

      // set requestAuthToken cookie
      const expiry = new Date(Date.now() + 1000 * 60 * 1)
      document.cookie = `requestAuthToken=true; path=/; domain=.easyvirtualchoir.com; expires=${expiry.toGMTString()}; SameSite=None; Secure`;

      const popupWindow = window.open(oauthUrl, 'OAuthPopup', `toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=yes, resizable=yes, copyhistory=no, width=${width}, height=${height}, top=${top}, left=${left}`);

      const gotToken = (authToken) => {
        localStorage['feathers-jwt'] = authToken
        clearInterval(pollInterval); // Stop polling
        const songId = extractIdFromPath(location.pathname)
        if (songId) {
          location.href = `/song/${songId}/record-track/multi`
        } else {
          location.reload()
        }
        popupWindow.close();
      }

      let pollInterval
      function checkForAuthToken() {
        const authToken = document.cookie.split('; ')
          .find(row => row.startsWith('authToken='))
          ?.split('=')[1];

        if (authToken) {
          // Delete the authToken
          document.cookie = "authToken=; path=/; domain=.easyvirtualchoir.com; expires=Thu, 01 Jan 1970 00:00:00 GMT";
          gotToken(authToken)
        }
      }

      // Poll every second
      setInterval(checkForAuthToken, 1000);

      // Setup message listener
      window.addEventListener('message', (event) => {
        if (event.origin !== 'https://easyvirtualchoir.com') return
        if (event.data.oauthToken) {
          gotToken(event.data.oauthToken)
        }
      }, false);
    }

    window.openOAuthPopup = openOAuthPopup


    bus.on('track-added', async () => {
      const resp = await fetch("/api/singalong", {
        "headers": {
          "content-type": "application/json",
          "Authorization": localStorage['feathers-jwt']
        },
        "method": "POST",
      });
      window.parent.postMessage({ event: 'track-added' }, "*");
    })
  })()
}

if (location.host === 'easyvirtualchoir.com') {
  const oauthToken = localStorage['feathers-jwt']
  window.opener?.postMessage({ oauthToken }, 'https://globalhatikvah.easyvirtualchoir.com')

  // Check if requesting auth token
  if (document.cookie.split(';').some((item) => item.trim().startsWith('requestAuthToken='))) {
    // Expire request
    document.cookie = "requestAuthToken=; path=/; domain=.easyvirtualchoir.com; expires=Thu, 01 Jan 1970 00:00:00 GMT";
    // document.cookie = "requestAuthToken=; path=/; domain=.easyvirtualchoir.com; expires=Thu, 01 Jan 1970 00:00:00 GMT; Secure";

    // Set auth token
    const expiry = new Date(Date.now() + 1000 * 60 * 5);
    document.cookie = `authToken=${oauthToken}; path=/; domain=.easyvirtualchoir.com; expires=${expiry.toGMTString()}; SameSite=None; Secure`;

    window.close()
    document.querySelector('footer')?.remove()
    document.querySelector('portal-page').innerHTML = `<div class="success-page my-6">
    <h1 class="title">Successfully signed in!</h1>
    <p class="subtitle">(You may close this window)</p>
</div>`
  }
}
